import { useEffect } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import CompanyLogo from "@/components/dashboard/CompanyLogo";
import WelcomeHeader from "@/components/dashboard/WelcomeHeader";
import DashboardStats from "@/components/dashboard/DashboardStats";
import RecentActivity from "@/components/dashboard/RecentActivity";
import OverdueInvoicesWidget from "@/components/dashboard/OverdueInvoicesWidget";
import QuickActionsBar from "@/components/dashboard/QuickActionsBar";
import { useDashboardData } from "@/hooks/useDashboardData";

const Dashboard = () => {
  const { user, profile, isLoading } = useAuth();
  const navigate = useNavigate();

  const { stats, recentActivity, isStatsLoading } = useDashboardData(user?.id);

  // Check if user needs profile setup
  useEffect(() => {
    if (!isLoading && profile && !profile.profile_completed) {
      navigate("/profile-setup", { replace: true });
    }
  }, [profile, isLoading, navigate]);

  useEffect(() => {
    const emailChangeSuccess = sessionStorage.getItem('email_change_success');
    if (emailChangeSuccess) {
      sessionStorage.removeItem('email_change_success');
      toast.success('Your email address has been updated successfully.');
    }
  }, []);

  return (
    <div className="max-w-7xl mx-auto w-full">
      <CompanyLogo profile={profile} />
      
      {/* Welcome Header with Quick Actions */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <WelcomeHeader profile={profile} />
        <QuickActionsBar />
      </div>
      
      <DashboardStats stats={stats} />
      
      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <OverdueInvoicesWidget />
        <RecentActivity 
          recentActivity={recentActivity} 
          isStatsLoading={isStatsLoading} 
        />
      </div>
    </div>
  );
};

export default Dashboard;
